export default __webpack_public_path__ + "static/media/IIV.45a03027.png";